import React from 'react';

import styled from 'styled-components';
import { pt, pb, px, mt, mb } from 'styled-components-spacing';
import { map } from 'styled-components-breakpoint';
import { colors, Text, Heading } from 'themes/components';

import HighlightText from 'utils/HighlightText';

import HeroCta from 'components/HeroCta';
import TrustedBy from 'components/TrustedBy';
import gridBg from './images/grid-bg.svg';
import underline from './images/underline.svg';
import heroVideoMp4 from './images/hero.mp4';

const Container = styled.div`
  text-align: center;
  ${pt({ mobile: 4, tablet: 8, desktop: 12 })};
  ${pb({ mobile: 2, tablet: 4 })};
  ${px(1)};
  background-image: url(${gridBg});
  background-repeat: no-repeat;
  ${map(
    {
      mobile: 'center bottom -200%',
      tablet: 'center bottom 5%',
      desktop: 'center bottom 5%'
    },
    (pos) => `background-position: ${pos};`
  )};
  & > h1 {
    margin: 0 auto;
    max-width: 750px;
  }
`;

const TextContainer = styled.div`
  margin: 0 auto;
  color: ${colors.grey5};
  ${map(
    {
      mobile: '350px',
      tablet: '70%',
      desktop: '600px'
    },
    (size) => `max-width: ${size};`
  )};
  ${mb(2)}
`;

const HeroImg = styled.div`
    margin: 0 auto;
    ${map(
      {
        mobile: '100%',
        tablet: '75%'
      },
      (size) => `max-width: ${size};`
    )};
  }
`;

const EmphasisText = styled(Text)`
  background: url(${underline}) no-repeat center top 35px;
  ${pb(2)};
  ${map(
    {
      mobile: '40%',
      tablet: '34%'
    },
    (bs) => `background-size: ${bs};`
  )};
`;

const Hero = ({}) => {
  return (
    <>
      <Container>
        <Heading variant="hero">
          <HighlightText
            direction="right"
            stopOne={colors.purple30}
            stopTwo={colors.teal40}
          >
            Iterate faster
          </HighlightText>
        </Heading>
        <TextContainer>
          <Text variant="subhead" hero>
            with Digital Asset Management custom built for artists and game
            studios.
          </Text>
        </TextContainer>
        <HeroCta />
      </Container>
      <HeroImg>
        <video autoPlay muted playsInline loop preload width="100%">
          <source src={heroVideoMp4} type="video/mp4" />
        </video>
      </HeroImg>
      <TrustedBy />
    </>
  );
};

export default Hero;
